var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle, _circle2, _path18, _circle3, _circle4, _circle5, _path19, _circle6, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _path28, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _circle7, _circle8, _path60, _path61, _path62;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAutoDepositIntro = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 185,
    viewBox: "0 0 252 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.01 179.304C85.9637 178.121 47.1657 175.344 24.6036 158.482C2.1559 141.733 -4.29099 110.9 7.11734 76.738C18.5257 42.5758 50.9545 13.1086 83.5194 8.31786C116.205 3.41427 149.147 23.0743 181.257 43.0739C213.361 63.2988 244.519 83.7508 248.626 109.322C252.732 134.893 229.787 165.582 204.085 177.122C178.383 188.661 150.05 180.711 118.01 179.304Z",
    fill: "#FA7B6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.372 67.3851C205.913 67.3851 205.541 67.7571 205.541 68.2161V72.193C205.541 72.6505 205.91 73.0216 206.367 73.024C205.91 73.0264 205.541 73.3975 205.541 73.8549V77.8319C205.541 78.2908 205.913 78.6629 206.372 78.6629H228.111C228.57 78.6629 228.942 78.2908 228.942 77.8319V73.8549C228.942 73.3975 228.573 73.0264 228.116 73.024C228.573 73.0215 228.942 72.6504 228.942 72.193V68.2161C228.942 67.7571 228.57 67.3851 228.111 67.3851H206.372ZM202.989 78.6629C202.53 78.6629 202.158 79.0349 202.158 79.4939V83.4708C202.158 83.9298 202.53 84.3018 202.989 84.3018H224.729C225.188 84.3018 225.56 83.9298 225.56 83.4708V79.4939C225.56 79.0349 225.188 78.6629 224.729 78.6629H202.989ZM225.56 89.1098C225.56 89.5675 225.19 89.9388 224.732 89.9408H229.803C230.262 89.9408 230.634 90.3128 230.634 90.7717V94.7487C230.634 95.2058 230.265 95.5767 229.809 95.5797C230.265 95.5826 230.634 95.9535 230.634 96.4106V100.388C230.634 100.845 230.264 101.217 229.807 101.219H233.187C233.646 101.219 234.018 101.591 234.018 102.05V106.026C234.018 106.485 233.646 106.857 233.187 106.857H229.806C230.264 106.859 230.634 107.23 230.634 107.688V111.665C230.634 112.124 230.262 112.496 229.803 112.496H208.064C207.605 112.496 207.233 112.124 207.233 111.665V107.688C207.233 107.23 207.605 106.857 208.064 106.857H211.445C210.987 106.856 210.616 106.485 210.616 106.026V102.05C210.616 101.592 210.986 101.22 211.444 101.219H208.064C207.605 101.219 207.233 100.847 207.233 100.388V96.4106C207.233 95.9535 207.602 95.5826 208.058 95.5797C207.602 95.5767 207.233 95.2058 207.233 94.7487V90.7717C207.233 90.314 207.603 89.9427 208.06 89.9408H202.989C202.53 89.9408 202.158 89.5687 202.158 89.1098V85.1328C202.158 84.6739 202.53 84.3018 202.989 84.3018H224.729C225.188 84.3018 225.56 84.6739 225.56 85.1328V89.1098ZM209.755 135.052C209.297 135.052 208.924 135.424 208.924 135.883V139.86C208.924 140.319 209.297 140.691 209.755 140.691H211.447C210.988 140.691 210.616 141.063 210.616 141.522V145.499C210.616 145.958 210.988 146.33 211.447 146.33H233.187C233.646 146.33 234.018 145.958 234.018 145.499V141.522C234.018 141.063 233.646 140.691 233.187 140.691H231.495C231.954 140.691 232.326 140.319 232.326 139.86V135.883C232.326 135.424 231.954 135.052 231.495 135.052H209.755ZM208.924 130.244C208.924 129.786 209.296 129.414 209.754 129.413C209.296 129.412 208.924 129.041 208.924 128.582V124.605C208.924 124.148 209.293 123.777 209.75 123.774C209.293 123.771 208.924 123.4 208.924 122.943V118.966C208.924 118.507 209.297 118.135 209.755 118.135H231.495C231.954 118.135 232.326 118.507 232.326 118.966V122.943C232.326 123.4 231.957 123.771 231.501 123.774C231.957 123.777 232.326 124.148 232.326 124.605V128.582C232.326 129.041 231.955 129.412 231.497 129.413C231.955 129.414 232.326 129.786 232.326 130.244V134.221C232.326 134.68 231.954 135.052 231.495 135.052H209.755C209.297 135.052 208.924 134.68 208.924 134.221V130.244ZM204.977 113.327C204.977 112.868 205.349 112.496 205.808 112.496H227.548C228.007 112.496 228.379 112.868 228.379 113.327V117.304C228.379 117.763 228.007 118.135 227.548 118.135H205.808C205.349 118.135 204.977 117.763 204.977 117.304V113.327Z",
    fill: "#F6DE05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M228.095 67.3851C228.563 67.3851 228.941 67.7638 228.941 68.2309V72.1782C228.941 72.6448 228.563 73.0232 228.097 73.024C228.563 73.0248 228.941 73.4032 228.941 73.8698V77.8171C228.941 78.2842 228.563 78.6629 228.095 78.6629L224.712 78.6629C225.179 78.6629 225.558 79.0416 225.558 79.5087V83.456C225.558 83.9228 225.18 84.3012 224.713 84.3018C225.18 84.3024 225.558 84.6809 225.558 85.1477V89.0949C225.558 89.562 225.179 89.9407 224.712 89.9407H229.787C230.254 89.9407 230.633 90.3194 230.633 90.7866V94.7338C230.633 95.201 230.254 95.5797 229.787 95.5797C230.254 95.5797 230.633 95.9584 230.633 96.4255V100.373C230.633 100.84 230.254 101.219 229.787 101.219H233.17C233.638 101.219 234.016 101.597 234.016 102.064V106.012C234.016 106.479 233.638 106.857 233.17 106.857H229.787C230.254 106.857 230.633 107.236 230.633 107.703V111.651C230.633 112.118 230.254 112.496 229.787 112.496H227.535C228 112.498 228.377 112.876 228.377 113.342V117.29C228.377 117.756 228 118.134 227.535 118.135H231.479C231.946 118.135 232.325 118.514 232.325 118.981V122.928C232.325 123.396 231.946 123.774 231.479 123.774C231.946 123.774 232.325 124.153 232.325 124.62V128.567C232.325 129.034 231.946 129.413 231.479 129.413C231.946 129.413 232.325 129.792 232.325 130.259V134.206C232.325 134.673 231.946 135.052 231.479 135.052C231.946 135.052 232.325 135.431 232.325 135.898V139.845C232.325 140.311 231.948 140.689 231.482 140.691H233.17C233.638 140.691 234.016 141.07 234.016 141.537V145.484C234.016 145.951 233.638 146.33 233.17 146.33H230.633C231.348 144.128 231.511 142.893 230.633 140.691L227.535 140.691C229.491 132.054 230.207 127.178 227.535 118.135H226.124C227.868 115.933 227.586 114.699 226.124 112.496H224.713C226.956 110.294 226.713 109.06 224.713 106.857H228.095C230.882 104.655 231.41 103.421 228.095 101.219H224.712C227.159 96.8143 228.69 94.345 224.712 89.9407H223.38C224.346 85.5364 224.393 83.0672 223.38 78.6629H222.049C223.481 74.2587 223.44 71.7893 222.049 67.3851H228.095Z",
    fill: "#F6F6F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M205.542 68.2309C205.542 67.7638 205.92 67.3851 206.387 67.3851H210.617C209.173 71.7893 209.504 74.2587 210.617 78.6629C207.761 82.8788 208.173 85.3753 210.617 89.9407C209.702 94.1966 209.211 96.5862 210.617 101.219H211.462H213.718C212.069 103.334 212.031 104.567 213.718 106.857C212.087 109.06 212.182 110.294 213.718 112.496C211.991 114.699 211.934 115.933 213.718 118.135C212.467 126.11 211.918 130.682 213.718 140.691H218.37C216.866 142.895 216.831 144.126 218.37 146.33H211.462C210.995 146.33 210.617 145.951 210.617 145.484V141.537C210.617 141.07 210.995 140.691 211.462 140.691H209.771C209.304 140.691 208.925 140.312 208.925 139.845V135.898C208.925 135.431 209.304 135.052 209.771 135.052C209.304 135.052 208.925 134.673 208.925 134.206V130.259C208.925 129.792 209.304 129.413 209.771 129.413C209.304 129.413 208.925 129.034 208.925 128.567V124.62C208.925 124.153 209.304 123.774 209.771 123.774C209.304 123.774 208.925 123.396 208.925 122.928V118.981C208.925 118.514 209.304 118.135 209.771 118.135H205.823C205.356 118.135 204.978 117.757 204.978 117.289V113.342C204.978 112.875 205.356 112.496 205.824 112.496H208.079C207.612 112.496 207.233 112.118 207.233 111.651V107.703C207.233 107.236 207.612 106.857 208.079 106.857H211.462C210.995 106.857 210.617 106.479 210.617 106.012V102.064C210.617 101.597 210.995 101.219 211.462 101.219H210.617H208.079C207.612 101.219 207.233 100.84 207.233 100.373V96.4255C207.233 95.9584 207.612 95.5797 208.079 95.5797C207.612 95.5797 207.233 95.201 207.233 94.7338V90.7866C207.233 90.3194 207.612 89.9407 208.079 89.9407H203.004C202.537 89.9407 202.158 89.562 202.158 89.0949V85.1477C202.158 84.6805 202.537 84.3018 203.004 84.3018C202.537 84.3018 202.158 83.9231 202.158 83.456V79.5087C202.158 79.0416 202.537 78.6629 203.004 78.6629H206.387C205.92 78.6629 205.542 78.2842 205.542 77.8171V73.8698C205.542 73.4027 205.92 73.024 206.387 73.024C205.92 73.024 205.542 72.6453 205.542 72.1782V68.2309Z",
    fill: "#FA7B6A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.684 107.689C162.684 107.23 163.056 106.858 163.515 106.858H185.254C185.713 106.858 186.085 107.23 186.085 107.689V111.665C186.085 112.124 185.713 112.496 185.254 112.496H163.515C163.056 112.496 162.684 112.124 162.684 111.665V107.689ZM168.323 118.966C168.323 118.507 168.695 118.135 169.154 118.135H171.97C171.513 118.134 171.142 117.762 171.142 117.304V113.327C171.142 112.869 171.514 112.496 171.973 112.496H193.713C194.172 112.496 194.544 112.869 194.544 113.327V117.304C194.544 117.763 194.172 118.135 193.713 118.135H190.897C191.354 118.137 191.725 118.508 191.725 118.966V122.943C191.725 123.402 191.353 123.774 190.895 123.774C191.353 123.775 191.725 124.147 191.725 124.605V128.582C191.725 129.04 191.355 129.411 190.897 129.413H196.532C196.991 129.413 197.363 129.785 197.363 130.244V134.221C197.363 134.68 196.991 135.052 196.532 135.052H193.716C194.173 135.054 194.544 135.425 194.544 135.883V139.86C194.544 140.317 194.175 140.688 193.718 140.691C194.175 140.694 194.544 141.065 194.544 141.522V145.499C194.544 145.958 194.172 146.33 193.713 146.33H171.973C171.514 146.33 171.142 145.958 171.142 145.499V141.522C171.142 141.065 171.511 140.694 171.968 140.691C171.511 140.688 171.142 140.317 171.142 139.86V135.883C171.142 135.424 171.514 135.052 171.973 135.052H174.79C174.332 135.05 173.962 134.679 173.962 134.221V130.244C173.962 129.786 174.332 129.415 174.789 129.413H169.154C168.695 129.413 168.323 129.041 168.323 128.582V124.605C168.323 124.146 168.695 123.774 169.154 123.774C168.695 123.774 168.323 123.402 168.323 122.943V118.966Z",
    fill: "#F6DE05"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M185.242 106.858C185.709 106.858 186.087 107.236 186.087 107.703V111.651C186.087 112.118 185.709 112.496 185.242 112.496L188.108 112.496H193.7C194.167 112.496 194.546 112.875 194.546 113.342V117.29C194.546 117.757 194.167 118.135 193.7 118.135H190.882C191.349 118.136 191.726 118.515 191.726 118.981V122.928C191.726 123.396 191.348 123.774 190.881 123.774C191.348 123.774 191.726 124.153 191.726 124.62V128.567C191.726 129.035 191.348 129.413 190.881 129.413H192.495L196.519 129.413C196.987 129.413 197.365 129.792 197.365 130.259V134.206C197.365 134.673 196.987 135.052 196.519 135.052H193.7C194.167 135.052 194.546 135.431 194.546 135.898V139.845C194.546 140.312 194.167 140.691 193.7 140.691C194.167 140.691 194.546 141.07 194.546 141.537V145.484C194.546 145.951 194.167 146.33 193.7 146.33H190.882C191.857 141.926 191.866 139.457 190.882 135.052H192.495C193.936 132.986 194.709 131.824 192.495 129.413H190.881L189.495 129.413C190.566 125.145 191.146 122.749 189.495 118.135H188.108C189.976 115.933 190.258 114.699 188.108 112.496H182.516C183.85 110.294 183.944 109.06 182.516 106.858H185.242Z",
    fill: "#F6F6F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M162.684 107.703C162.684 107.236 163.062 106.858 163.529 106.858H173.659C171.988 108.749 171.988 111.651 173.659 112.496C172.921 113.905 172.842 115.749 173.377 118.135C172.342 122.184 171.988 127.941 174.384 129.413H174.807H177.627C175.988 129.86 176.18 134.206 176.8 135.052C174.807 136.961 174.807 145.484 177.627 146.33H171.988C171.521 146.33 171.142 145.951 171.142 145.484V141.537C171.142 141.07 171.521 140.691 171.988 140.691C171.521 140.691 171.142 140.312 171.142 139.845V135.898C171.142 135.431 171.521 135.052 171.988 135.052H174.807C174.34 135.052 173.961 134.673 173.961 134.206V130.259C173.961 129.792 174.34 129.413 174.807 129.413H174.384H169.168C168.701 129.413 168.323 129.035 168.323 128.567V124.62C168.323 124.153 168.701 123.774 169.168 123.774C168.701 123.774 168.323 123.396 168.323 122.928V118.981C168.323 118.514 168.701 118.135 169.168 118.135H171.988C171.521 118.135 171.142 117.757 171.142 117.29V113.342C171.142 112.875 171.521 112.496 171.988 112.496H163.529C163.062 112.496 162.684 112.118 162.684 111.651V107.703Z",
    fill: "#FA7B6A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.041 118.135C134.582 118.135 134.21 118.507 134.21 118.966V122.943C134.21 123.402 134.582 123.774 135.041 123.774H137.575C137.117 123.776 136.747 124.147 136.747 124.605V128.582C136.747 129.041 137.119 129.413 137.578 129.413H159.317C159.776 129.413 160.148 129.041 160.148 128.582V124.605C160.148 124.146 159.776 123.774 159.317 123.774H156.783C157.241 123.772 157.611 123.401 157.611 122.943V118.966C157.611 118.507 157.239 118.135 156.78 118.135H135.041ZM133.928 130.244C133.928 129.785 134.3 129.413 134.759 129.413H156.498C156.957 129.413 157.329 129.785 157.329 130.244V134.221C157.329 134.679 156.958 135.051 156.5 135.052C156.958 135.053 157.329 135.425 157.329 135.883V139.86C157.329 140.316 156.962 140.687 156.506 140.691H162.419C162.878 140.691 163.25 141.063 163.25 141.522V145.499C163.25 145.958 162.878 146.33 162.419 146.33H140.679C140.22 146.33 139.848 145.958 139.848 145.499V141.522C139.848 141.066 140.216 140.695 140.671 140.691H134.759C134.3 140.691 133.928 140.319 133.928 139.86V135.883C133.928 135.425 134.299 135.053 134.757 135.052C134.299 135.051 133.928 134.679 133.928 134.221V130.244Z",
    fill: "#F6DE05"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M157.61 122.928C157.61 123.396 157.231 123.774 156.764 123.774L154.766 123.774L159.302 123.774C159.769 123.774 160.148 124.153 160.148 124.62V128.567C160.148 129.034 159.769 129.413 159.302 129.413H156.484C156.95 129.414 157.328 129.792 157.328 130.259V134.206C157.328 134.673 156.95 135.052 156.482 135.052C156.95 135.052 157.328 135.431 157.328 135.898V139.845C157.328 140.312 156.95 140.691 156.482 140.691H159.302L162.403 140.691C162.87 140.691 163.249 141.07 163.249 141.537V145.484C163.249 145.951 162.87 146.33 162.403 146.33H160.148H159.302C160.214 144.128 160.289 142.893 159.302 140.691H156.482H152.768C154.554 136.287 154.791 133.817 152.768 129.413H154.766C156.331 127.211 156.859 125.976 154.766 123.774L152.768 123.774C154.918 121.662 154.938 120.428 152.768 118.135H156.764C157.231 118.135 157.61 118.514 157.61 118.981V122.928Z",
    fill: "#F6F6F1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M134.21 118.981C134.21 118.514 134.588 118.135 135.056 118.135H147.461C145.995 118.685 144.799 119.753 144.36 120.814C143.785 122.201 144.36 123.774 144.36 123.774C144.36 123.774 142.952 124.716 142.527 126.171C142.165 127.412 142.569 129.068 143.358 129.367C144.104 129.36 144.505 129.367 143.655 129.413C143.551 129.419 143.452 129.402 143.358 129.367C142.345 129.377 140.694 129.413 140.694 129.413C138.721 132.797 138.016 138.294 140.694 140.691H143.655C142.899 142.811 142.838 144.769 143.655 146.33H140.694C140.227 146.33 139.849 145.951 139.849 145.484V141.537C139.849 141.07 140.227 140.691 140.694 140.691H134.774C134.306 140.691 133.928 140.312 133.928 139.845V135.898C133.928 135.431 134.306 135.052 134.774 135.052C134.306 135.052 133.928 134.673 133.928 134.206V130.259C133.928 129.792 134.306 129.413 134.774 129.413H137.593C137.126 129.413 136.747 129.034 136.747 128.567V124.62C136.747 124.153 137.126 123.774 137.593 123.774H135.056C134.588 123.774 134.21 123.396 134.21 122.928V118.981Z",
    fill: "#FA7B6A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.152 123.774C104.694 123.774 104.321 124.146 104.321 124.605V128.582C104.321 129.04 104.692 129.411 105.149 129.413H102.333C101.874 129.413 101.502 129.785 101.502 130.244V134.221C101.502 134.68 101.874 135.052 102.333 135.052C101.874 135.052 101.502 135.424 101.502 135.883V139.86C101.502 140.318 101.873 140.69 102.331 140.691C101.873 140.692 101.502 141.064 101.502 141.522V145.499C101.502 145.958 101.874 146.33 102.333 146.33H124.072C124.531 146.33 124.903 145.958 124.903 145.499V141.522C124.903 141.064 124.533 140.692 124.075 140.691C124.533 140.69 124.903 140.318 124.903 139.86V135.883C124.903 135.425 124.532 135.053 124.074 135.052C124.532 135.051 124.903 134.679 124.903 134.221V130.244C124.903 129.786 124.533 129.415 124.076 129.413H126.892C127.351 129.413 127.723 129.041 127.723 128.582V124.605C127.723 124.146 127.351 123.774 126.892 123.774H105.152Z",
    fill: "#F6DE05"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M124.06 146.33C124.527 146.33 124.905 145.951 124.905 145.484V141.537C124.905 141.07 124.527 140.691 124.06 140.691C124.527 140.691 124.905 140.312 124.905 139.845V135.898C124.905 135.431 124.527 135.052 124.06 135.052C124.527 135.052 124.905 134.673 124.905 134.206V130.259C124.905 129.792 124.527 129.413 124.06 129.413H123.895H120.91C122.832 138.251 122.919 142.058 120.91 146.33H124.06Z",
    fill: "#F6F6F1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M105.167 123.774C104.7 123.774 104.321 124.153 104.321 124.62V128.567C104.321 129.034 104.7 129.413 105.167 129.413H102.348C101.881 129.413 101.502 129.792 101.502 130.259V134.206C101.502 134.673 101.881 135.052 102.348 135.052C101.881 135.052 101.502 135.431 101.502 135.898V139.845C101.502 140.312 101.881 140.691 102.348 140.691C101.881 140.691 101.502 141.07 101.502 141.537V145.484C101.502 145.951 101.881 146.33 102.348 146.33H109.114C103.546 139.733 120.214 132.356 124.903 132.233V130.259C124.903 129.792 124.525 129.413 124.058 129.413H126.877C127.344 129.413 127.723 129.034 127.723 128.567V124.62C127.723 124.153 127.344 123.774 126.877 123.774H105.167Z",
    fill: "#FA7B6A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4902 130.244C70.4902 129.785 70.8623 129.413 71.3212 129.413H93.0607C93.5197 129.413 93.8917 129.785 93.8917 130.244V134.221C93.8917 134.679 93.5209 135.051 93.063 135.052C93.5209 135.053 93.8917 135.425 93.8917 135.883V139.86C93.8917 140.319 93.5197 140.691 93.0607 140.691H89.1214C89.5767 140.695 89.9445 141.066 89.9445 141.522V145.499C89.9445 145.958 89.5724 146.33 89.1135 146.33H67.374C66.915 146.33 66.543 145.958 66.543 145.499V141.522C66.543 141.063 66.915 140.691 67.374 140.691H71.3133C70.858 140.687 70.4902 140.316 70.4902 139.86V135.883C70.4902 135.425 70.861 135.053 71.3189 135.052C70.861 135.051 70.4902 134.679 70.4902 134.221V130.244Z",
    fill: "#F6DE05"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0451 129.413C93.5123 129.413 93.891 129.792 93.891 130.259V134.206C93.891 134.673 93.5123 135.052 93.0451 135.052C93.5123 135.052 93.891 135.431 93.891 135.898V139.845C93.891 140.312 93.5123 140.691 93.0451 140.691H89.9437H89.0979C89.565 140.691 89.9437 141.07 89.9437 141.537V145.484C89.9437 145.951 89.565 146.33 89.0979 146.33H85.2129C85.2129 146.33 86.794 142.893 85.2129 140.691H89.0979H89.9437C91.1526 136.287 91.3113 133.817 89.9437 129.413H93.0451Z",
    fill: "#F6F6F1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4902 130.259C70.4902 129.792 70.8689 129.413 71.336 129.413H85.5743C81.5981 130.387 75.3463 134.923 77.1159 139.845C75.013 142.378 74.6978 143.797 77.1159 146.33H67.3888C66.9217 146.33 66.543 145.951 66.543 145.484V141.537C66.543 141.07 66.9217 140.691 67.3888 140.691H71.336C70.8689 140.691 70.4902 140.312 70.4902 139.845V135.898C70.4902 135.431 70.8689 135.052 71.336 135.052C70.8689 135.052 70.4902 134.673 70.4902 134.206V130.259Z",
    fill: "#FA7B6A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9904 135.052C32.5232 135.052 32.1445 135.431 32.1445 135.898V139.845C32.1445 140.312 32.5232 140.691 32.9904 140.691H36.6526C36.1867 140.692 35.8095 141.071 35.8095 141.537V145.484C35.8095 145.951 36.1882 146.33 36.6553 146.33H58.3652C58.8323 146.33 59.211 145.951 59.211 145.484V141.537C59.211 141.07 58.8323 140.691 58.3652 140.691H54.7029C55.1688 140.69 55.546 140.311 55.546 139.845V135.898C55.546 135.431 55.1674 135.052 54.7002 135.052H32.9904Z",
    fill: "#F6DE05"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5463 139.845C55.5463 140.312 55.1676 140.691 54.7005 140.691L58.3658 140.691C58.8329 140.691 59.2116 141.07 59.2116 141.537V145.484C59.2116 145.951 58.8329 146.33 58.3658 146.33H52.0124C53.5153 144.128 53.5406 142.893 52.0124 140.691H49.3242C51.0333 138.489 51.1255 137.254 49.3242 135.052H54.7005C55.1676 135.052 55.5463 135.431 55.5463 135.898V139.845Z",
    fill: "#F6F6F1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9904 135.052C32.5232 135.052 32.1445 135.431 32.1445 135.898V139.845C32.1445 140.312 32.5232 140.691 32.9904 140.691H36.6557C36.1885 140.691 35.8098 141.07 35.8098 141.537V145.484C35.8098 145.951 36.1885 146.33 36.6557 146.33H39.7571C38.2498 144.127 38.1816 142.893 39.7571 140.691H38.4883C36.7138 138.489 36.4362 137.254 38.4883 135.052H32.9904Z",
    fill: "#FA7B6A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85.854,
    cy: 9.72712,
    r: 8.8813,
    fill: "#FA7B6A",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.9829,
    cy: 8.8813,
    r: 8.8813,
    fill: "#F6DE05"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8918 0.904175L79.0059 12.7901C79.6803 14.1639 80.6992 15.338 81.9499 16.1998L94.3015 3.84826C93.4397 2.59753 92.2656 1.57863 90.8918 0.904175Z",
    fill: "#F6F6F1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.9829,
    cy: 8.8813,
    r: 8.8813,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.018,
    cy: 37.3579,
    r: 8.8813,
    fill: "#FA7B6A",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.4536,
    cy: 36.23,
    r: 8.8813,
    fill: "#F6DE05"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8419 28.5068L54.7305 40.6183C55.3883 41.7735 56.2978 42.7668 57.3845 43.5235L69.7471 31.1608C68.9905 30.0742 67.9972 29.1647 66.8419 28.5068Z",
    fill: "#F6F6F1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.4536,
    cy: 36.23,
    r: 8.8813,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6705 33.7799C64.5715 31.9643 58.7018 30.2857 58.7628 33.7066C58.8232 36.6022 64.7605 35.6194 64.4582 38.8944C64.1515 42.1063 58.9255 39.8547 57.7676 38.635",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2419 40.0983L59.3848 41.5475",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7227 32.0544L64.4191 30.7321",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3928 4.22919C85.5705 4.22919 80.4983 7.47157 84.172 9.65945C85.5135 10.2401 87.6363 8.94298 89.0835 8.89537C90.3664 8.74032 91.7761 9.65945 91.2122 11.2778C90.5074 12.6876 86.9921 13.8175 85.0404 13.6772",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8145 12.9695L89.4996 14.6612",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1504 3.38336L85.6945 4.79309",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0957 45.5511V146.471H238.692",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1445 135.898C32.1445 135.431 32.5232 135.052 32.9904 135.052H54.7002C55.1674 135.052 55.546 135.431 55.546 135.898V139.845C55.546 140.312 55.1674 140.691 54.7002 140.691H32.9904C32.5232 140.691 32.1445 140.312 32.1445 139.845V135.898Z",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70.4902,
    y: 135.052,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70.4902,
    y: 129.413,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 101.502,
    y: 129.413,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 208.924,
    y: 135.052,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 207.232,
    y: 106.858,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 104.322,
    y: 123.774,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 171.145,
    y: 140.691,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 208.924,
    y: 129.413,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 210.615,
    y: 101.219,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 173.963,
    y: 129.413,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 171.145,
    y: 135.052,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 208.924,
    y: 123.774,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 207.232,
    y: 95.5797,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 168.324,
    y: 118.135,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 168.324,
    y: 123.774,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 208.924,
    y: 118.135,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 207.232,
    y: 89.9407,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 162.684,
    y: 106.858,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 171.145,
    y: 112.496,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 204.977,
    y: 112.496,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 202.158,
    y: 78.6628,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 205.541,
    y: 67.3851,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 202.158,
    y: 84.3019,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 205.541,
    y: 73.024,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 101.502,
    y: 135.052,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 210.615,
    y: 140.691,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 101.502,
    y: 140.691,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8086 141.537C35.8086 141.07 36.1873 140.691 36.6544 140.691H58.3643C58.8314 140.691 59.2101 141.07 59.2101 141.537V145.484C59.2101 145.951 58.8314 146.33 58.3643 146.33H36.6544C36.1873 146.33 35.8086 145.951 35.8086 145.484V141.537Z",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 66.543,
    y: 140.691,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 133.928,
    y: 129.413,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 136.746,
    y: 123.774,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 134.209,
    y: 118.135,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 133.928,
    y: 135.052,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 139.848,
    y: 140.691,
    width: 23.4015,
    height: 5.63892,
    rx: 0.830984,
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M133.834 66.1219C132.906 63.9058 132.461 61.8645 132.094 59.4906C131.742 57.1987 130.825 52.8902 128.418 52.8902C126.314 52.8902 123.869 55.6303 122.79 57.376C115.584 69.0403 122.803 64.964 133.831 66.1163L133.834 66.1219Z",
    fill: "#F6F6F1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M122.79 57.376C123.869 55.6303 126.314 52.8902 128.418 52.8902C128.759 52.8902 129.07 52.9766 129.354 53.1315C124.594 56.0796 125.963 62.8664 127.242 65.8913C120.332 65.9946 117.163 66.4846 122.79 57.376Z",
    fill: "#FA7B6A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8546 129.695C83.2732 129.908 77.6782 127.44 76.6914 125.466C81.6703 119.091 86.1912 120.17 93.1852 123.492C90.7887 125.889 87.2644 129.695 85.8546 129.695Z",
    fill: "#FA7B6A",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M141.485 108.358C142.451 111.302 143.992 114.058 145.998 116.423C147.116 117.748 141 121.759 139.771 120.65C136.04 117.329 136.713 110.664 141.488 108.355L141.485 108.358Z",
    fill: "#FA7B6A",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M133.834 66.1219C132.906 63.9058 132.461 61.8645 132.094 59.4906C131.742 57.1987 130.825 52.8902 128.418 52.8902C126.314 52.8902 123.869 55.6303 122.79 57.376C115.584 69.0403 122.803 64.964 133.831 66.1163L133.834 66.1219Z",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5811 102.205C58.6129 73.7031 86.7195 61.6586 109.397 60.7593C132.94 60.7593 147.932 70.1886 145.627 90.3636C143.732 106.919 131.953 119.357 114.472 122.505C93.6823 126.25 68.0204 127.616 63.5811 102.205Z",
    fill: "#F6F6F1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9092 71.1333C80.6062 69.9818 80.0944 69.0139 78.8789 69.2977C85.2307 65.414 101.333 60.7697 109.394 60.5778C109.394 60.5778 110.932 67.6548 110.162 65.7596C107.667 59.6182 82.9092 71.1333 82.9092 71.1333Z",
    fill: "#FA7B6A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5811 102.205C68.0204 127.616 93.6823 126.25 114.472 122.505C124.325 120.731 132.367 116.005 137.848 109.254C79.511 136.603 61.6075 106.434 65.1336 84.5837C63.0894 89.5735 62.399 95.4235 63.5811 102.205Z",
    fill: "#FA7B6A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M127.724 63.2383C122.502 61.5745 116.319 60.7593 109.397 60.7593C86.7195 61.6586 58.6129 73.7031 63.5811 102.205C68.0204 127.616 93.6823 126.25 114.472 122.505C131.953 119.357 143.732 106.919 145.627 90.3636C147.02 78.1721 142.097 69.9045 132.787 65.2704",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M140.763 78.2456C142.932 78.0573 145.768 77.9552 148.945 77.9552C151.366 79.0806 151.548 89.7998 146.191 92.4782C146.191 98.1172 143.907 106.781 142.486 108.904C139.498 113.365 138.512 116.484 141.307 121.228C138.538 122.905 130.241 125.799 130.241 125.799C127.155 125.349 122.219 121.014 124.157 117.803C131.375 105.84 136.489 92.6136 140.763 78.2456Z",
    fill: "#F6F6F1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M124.157 117.803C122.219 121.014 127.155 125.349 130.241 125.799C130.241 125.799 131.373 125.404 132.939 124.822C126.68 124.757 125.926 117.612 126.332 114.047C125.628 115.312 124.904 116.564 124.157 117.803Z",
    fill: "#FA7B6A"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M146.191 92.4782C147.531 91.8084 148.524 90.6356 149.222 89.2358C147.951 90.3166 144.823 92.4782 142.486 92.4782C139.565 92.4782 145.628 98.2581 144.057 105.025C145.163 101.407 146.191 96.2617 146.191 92.4782Z",
    fill: "#FA7B6A"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M140.763 78.2456C142.932 78.0573 145.768 77.9552 148.945 77.9552C151.366 79.0806 151.548 89.7998 146.191 92.4782C146.191 98.1172 143.907 106.781 142.486 108.904C139.498 113.365 138.512 116.484 141.307 121.228C138.538 122.905 130.241 125.799 130.241 125.799C127.155 125.349 122.219 121.014 124.157 117.803",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M147.874 82.0067C147.381 81.4908 146.699 80.9297 146.036 81.1919C145.746 81.3075 145.537 81.5613 145.357 81.815C144.257 83.3516 143.679 85.2209 143.499 87.1043C143.448 87.6428 143.428 88.1983 143.6 88.7114C143.772 89.2246 144.167 89.6898 144.694 89.811C145.309 89.952 145.949 89.5883 146.324 89.0808C146.699 88.5733 146.859 87.9445 147.014 87.3327",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1113 123.391C71.7156 126.264 75.4231 128.701 77.8592 129.179C81.203 129.836 86.964 124.05 89.0976 121.894C80.9618 119.425 75.6407 115.715 72.7447 112.496C72.7447 112.496 73.3086 113.201 70.1113 123.391Z",
    fill: "#FA7B6A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0976 121.894C86.964 124.05 81.203 129.836 77.8592 129.179C75.4231 128.701 71.7156 126.264 70.1113 123.391C73.3086 113.201 72.7447 112.496 72.7447 112.496",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6934 97.15C46.2409 86.8392 58.0826 92.3372 53.5321 96.0025C50.3291 97.15 51.0317 91.8803 53.0076 90.5045C56.109 87.9671 62.8107 89.8391 64.4775 93.902",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6132 69.0767C86.5604 66.2573 94.5057 63.6944 102.07 62.5807C105.169 62.1245 106.006 65.0251 102.772 65.8343C97.6889 67.1064 90.8883 69.4658 84.5868 71.7552C82.1888 72.6272 80.2167 70.3455 82.6132 69.0767Z",
    fill: "#1C1C1C"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M102.07 62.5807C94.5057 63.6944 86.5604 66.2573 82.6132 69.0767C81.5197 69.6556 81.3357 70.4455 81.6868 71.0503C81.757 69.7816 98.8251 62.5807 104.746 63.5788C104.467 62.8846 103.514 62.3681 102.07 62.5807Z",
    fill: "#FA7B6A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6855 71.0503C81.7558 69.7816 98.8239 62.5807 104.745 63.5788",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6132 69.0767C86.5604 66.2573 94.5057 63.6944 102.07 62.5807C105.169 62.1245 106.006 65.0251 102.772 65.8343C97.6889 67.1064 90.8883 69.4658 84.5868 71.7552C82.1888 72.6272 80.2167 70.3455 82.6132 69.0767Z",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.128 66.2662C102.077 64.8532 102.63 63.1528 102.63 61.3232C102.63 56.4182 98.6535 52.4419 93.7485 52.4419C88.8435 52.4419 84.8672 56.4182 84.8672 61.3232C84.8672 65.111 87.2385 68.345 90.5775 69.6217C94.3068 68.3275 97.9701 67.1325 101.128 66.2662Z",
    fill: "#FA7B6A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M101.128 66.2662L101.234 66.6519L101.377 66.6126L101.46 66.4891L101.128 66.2662ZM90.5775 69.6217L90.4347 69.9953L90.5709 70.0474L90.7087 69.9996L90.5775 69.6217ZM102.23 61.3232C102.23 63.0709 101.702 64.6941 100.796 66.0433L101.46 66.4891C102.452 65.0122 103.03 63.2346 103.03 61.3232H102.23ZM93.7485 52.8419C98.4326 52.8419 102.23 56.6391 102.23 61.3232H103.03C103.03 56.1973 98.8744 52.0419 93.7485 52.0419V52.8419ZM85.2672 61.3232C85.2672 56.6391 89.0644 52.8419 93.7485 52.8419V52.0419C88.6226 52.0419 84.4672 56.1973 84.4672 61.3232H85.2672ZM90.7204 69.2481C87.531 68.0286 85.2672 64.9398 85.2672 61.3232H84.4672C84.4672 65.2823 86.9459 68.6614 90.4347 69.9953L90.7204 69.2481ZM101.022 65.8804C97.8517 66.7502 94.1789 67.9485 90.4464 69.2438L90.7087 69.9996C94.4347 68.7065 98.0884 67.5148 101.234 66.6519L101.022 65.8804Z",
    fill: "#1C1C1C"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.676 66.3918C102.234 64.7916 103.194 62.6056 103.194 60.1954C103.194 55.2904 99.2179 51.3141 94.3129 51.3141C89.4079 51.3141 85.4316 55.2904 85.4316 60.1954C85.4316 64.5253 88.5301 68.1314 92.6306 68.9176C95.4653 67.9575 98.2133 67.0809 100.676 66.3918Z",
    fill: "#F6DE05"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3423 52.2783L86.3965 64.2242C86.8045 65.0243 87.3302 65.7544 87.9509 66.3916L100.51 53.8327C99.8726 53.2121 99.1425 52.6863 98.3423 52.2783Z",
    fill: "#F6F6F1"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M100.676 66.3918L100.783 66.777L100.887 66.748L100.962 66.6709L100.676 66.3918ZM92.6306 68.9176L92.5553 69.3105L92.659 69.3303L92.7589 69.2965L92.6306 68.9176ZM102.794 60.1954C102.794 62.4972 101.878 64.5842 100.389 66.1127L100.962 66.6709C102.59 64.999 103.594 62.7141 103.594 60.1954H102.794ZM94.3129 51.7141C98.997 51.7141 102.794 55.5114 102.794 60.1954H103.594C103.594 55.0695 99.4389 50.9141 94.3129 50.9141V51.7141ZM85.8316 60.1954C85.8316 55.5114 89.6288 51.7141 94.3129 51.7141V50.9141C89.187 50.9141 85.0316 55.0695 85.0316 60.1954H85.8316ZM92.7059 68.5248C88.7903 67.774 85.8316 64.3298 85.8316 60.1954H85.0316C85.0316 64.7207 88.2698 68.4888 92.5553 69.3105L92.7059 68.5248ZM100.568 66.0066C98.096 66.6983 95.3406 67.5774 92.5023 68.5388L92.7589 69.2965C95.59 68.3376 98.3306 67.4634 100.783 66.777L100.568 66.0066Z",
    fill: "#1C1C1C"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4844 91.3505C81.8143 93.7075 84.3912 95.0609 85.3893 97.2206",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5117 95.0157C80.2222 96.6933 82.3678 97.494 82.8782 99.2449",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1853 55.517C90.4912 55.6846 89.1447 61.5298 94.7098 60.1426C98.1383 59.288 99.253 62.6612 95.8271 63.8471C94.5402 64.2993 93.1768 64.4789 91.8233 64.6552",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2695 64.2527L95.9246 65.9753",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3184 54.1336L92.9624 55.9695",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.148,
    cy: 74.0108,
    r: 2.11459,
    fill: "#1C1C1C"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.324,
    cy: 73.1649,
    r: 2.11459,
    fill: "#1C1C1C"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M123.492 65.8511C118.59 65.9468 113.687 66.0425 108.862 65.9109C108.48 60.4711 112.06 52.8853 118.075 52.1846C123.158 51.5925 120.051 61.8379 123.495 65.8541L123.492 65.8511Z",
    fill: "#F6F6F1"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M114.768 66.7191C111.313 64.9919 115.151 53.8606 118.074 52.1846C113.315 52.739 110.081 57.6035 109.126 62.305C103.252 67.8706 114.767 68.0626 114.768 66.7191Z",
    fill: "#FA7B6A"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M123.492 65.8511L123.495 65.8541C120.051 61.8379 123.158 51.5925 118.075 52.1846C112.06 52.8853 108.48 60.4711 108.862 65.9109",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAutoDepositIntro);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/auto_deposit_intro.0e101a02cc2c7b9a8c4249e7382093a5.svg";